import React, { useEffect } from "react";
import NavBar from "../Components/Navbar/NavBarSection/NavBar";
import { useSelector } from "react-redux";
import { Redirect, Route, Switch, useLocation } from "react-router-dom";

import ProtectedRoute from "../Components/Auth/ProtectedRoute";
import Developers from "../Components/Recruiter/Developers";
import ApplicationStatus from "../Components/Developer/ApplicationStatus";
import Calendly from "../Components/Admin/pages/calendly";
// import UserHome from "../Pages/Home/UserHome";
import Careers from "../Pages/Careers/Careers";
import ApplyNow from "../Pages/ApplyNow/ApplyNow";
import PrivacyPolicy from "../Pages/PrivacyPolicy/PrivacyPolicy";
import NotFound from "../Components/NotFoundSection/NotFound";
import Whatsapp_Link_Spinner from "../Components/Whatsapp_Link_Spinner";

import Home from "../Components/Home/HomeSection/Home";
// import Products from "../Components/Home/ProductSection/Products";
// import HireAIExpertModal from "../Components/Modals/HireAIExpertModal/HireAIExpertModal";
import Info from "../Components/Home/Info";
import Footer from "../Components/Home/FooterSection/Footer";
import Experience from "../Components/Home/Categories/Experience";
import Skills from "../Components/Home/Categories/Skills";
import WorldRecords from "../Components/Home/Categories/WorldRecords";
import ServicesCategory from "../Components/Home/Categories/ServicesCategory";
import Our from "../Components/Home/Categories/Our";
import ProductsPage from "../Components/Home/Categories/ProductsPage";
import TokenSync from "../Components/Auth/Login/TokenSync";
import LogoutSync from "../Components/Auth/Login/LogoutSync";

const Layout = () => {
    const { isLoggedIn, tabs } = useSelector(state => state.sessionHandler);
    const token = localStorage.getItem('token')
    const location = useLocation();
    // Check if the current path is "/a/:uid" (dynamic route)
    const isOnDynamicRoute = /^\/a\/[^/]+$/.test(location.pathname);
    const isOnAuthSyncRoute =
        location.pathname === "/token-sync" || location.pathname === "/logout-sync";

    // Hide or show the chatbot trigger based on the route
    useEffect(() => {
        let chatbotTrigger = document.getElementById('chatbot-trigger');
        let observer = null;

        // Function to update chatbot visibility
        const updateChatbotVisibility = () => {
            chatbotTrigger = document.getElementById('chatbot-trigger');
            if (chatbotTrigger) {
                // Use display: none to hide or block to show the chatbot
                chatbotTrigger.style.visibility = isOnDynamicRoute ? 'hidden' : 'visible';
                if (observer) {
                    observer.disconnect();  // Disconnect observer once we've handled the element
                }

            }
        };

        // Handle the immediate visibility change
        updateChatbotVisibility();

        // Observe DOM mutations for the addition of the chatbot trigger element
        if (!chatbotTrigger) {
            observer = new MutationObserver(() => {
                updateChatbotVisibility();
            });

            observer.observe(document.body, { childList: true, subtree: true });
        }

        // Cleanup observer on unmount
        return () => {
            if (observer) observer.disconnect();
        };
    }, [location.pathname, isOnDynamicRoute]);

    return (
        <React.Fragment>
            {/* Render NavBar only if not on "/a/:uid" route */}
            {!isOnDynamicRoute && !isOnAuthSyncRoute && <NavBar />}
            {!isLoggedIn && (
                <Switch>
                    <Route exact path="/" component={Home} />
                    <Route exact path="/hire-ai-experts" component={Home} />
                    <Route exact path="/thank-you" component={Home} />
                    <Route exact path="/experience" component={Experience} />
                    <Route exact path="/trusted-by-leading-brands" component={Experience} />
                    <Route exact path="/hire-ex-experts" component={Experience} />
                    <Route exact path="/hear-from-our-clients" component={Experience} />
                    <Route exact path="/skills" component={Skills} />
                    <Route exact path="/techstack" component={Skills} />
                    <Route exact path="/areaexpertise" component={Skills} />
                    <Route exact path="/world-records" component={WorldRecords} />
                    <Route exact path="/guinness-world-records" component={WorldRecords} />
                    <Route exact path="/awards-and-recognition" component={WorldRecords} />
                    <Route exact path="/services" component={ServicesCategory} />
                    <Route exact path="/services-we-offer" component={ServicesCategory} />
                    <Route exact path="/industry-verticals" component={ServicesCategory} />
                    <Route exact path="/aboutus" component={Our} />
                    <Route exact path="/ourculture" component={Our} />
                    <Route exact path="/ourfounders" component={Our} />
                    <Route exact path="/products" component={ProductsPage} />
                    <Route exact path="/haveto" component={ProductsPage} />
                    <Route exact path="/8080.ai" component={ProductsPage} />
                    {/* <Route exact path="/contact" component={Info} /> */}
                    <Route path="/careers" component={Careers} />
                    <Route path="/apply_now" component={ApplyNow} />
                    <Route path="/privacy-policy" component={PrivacyPolicy} />
                    <Route path="/a/:uuid" component={Whatsapp_Link_Spinner} />
                    <Route path="/token-sync" component={TokenSync} />
                    <Route path="/logout-sync" component={LogoutSync} />
                    <Route component={NotFound} />
                </Switch>
            )}

            {isLoggedIn && (
                <React.Fragment>
                    <ProtectedRoute
                        path="/recruiter/developers"
                        component={Developers}
                    />

                    <ProtectedRoute
                        path="/developer/application-status"
                        component={ApplicationStatus}
                    />

                    <ProtectedRoute
                        path="/admin/calendly"
                        component={Calendly}
                    />

                    <Redirect exact from={"/"} to={tabs[0].path} />
                </React.Fragment>
            )}
            <div id="aimated-cursor">
                <div id="cursor">
                    <div id="cursor-loader" />
                </div>
            </div>
            {!isOnDynamicRoute && (
                <>
                    {!isOnDynamicRoute && !isOnAuthSyncRoute && (
                        <>
                            <Info />
                            <Footer />
                        </>
                    )}
                </>
            )}
        </React.Fragment>
    );
};

export default Layout;
